export enum AmendExplanationDialogFormNamesEnum {
  FORM_GROUP_NAME = 'AmendExplanation',
  REASON_CODE = 'ReasonCode',
  REASON_EXPLANATION = 'ReasonExplanation',
  CC_EMAILS = 'ccEmails',
}
